import Component from '../abstracts/Component';
import CartLayerLogic from '../businessLogic/CartLayerLogic';

export default class CartLayerComponent extends Component {

  get SELECTORS() {
    return {
      main: '.l-quick-cart',
      content: '.l-q-c__items-container',
      items: '.l-q-c__item',
      dataQty: '[data-mcqty]',
    };
  }

  constructor() {
    super();
  }
  setDataQty(qty) {
    let dataAttributes = document.querySelectorAll(this.SELECTORS.dataQty);
    for (let dataAttr of dataAttributes) {
      //not dataAttr.dataset.mcqty = qty; for IE11
      $(dataAttr).attr("data-mcqty",qty);
    }
  }

  counterList() {
    let itemsEl = document.querySelectorAll(this.SELECTORS.items);
    this.setDataQty(itemsEl.length);
  }

  render() {
    this.log('Rendering...');
    this.CartLayerLogic = new CartLayerLogic(this);
    this.CartLayerLogic.render();
    if (document.querySelectorAll(this.SELECTORS.items).length)
      this.counterList();
  }
}
